module.exports = __webpack_public_path__ + "img/rzsj01.8f6bccc6.jpg";